module.exports = __webpack_public_path__ + "media/student_v2/assets/images/rocket_earth-0e0fb43bad8c5902860e3e592115cf17.svg";